/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Мета пагинации (generate_meta_paginate)
 * @export
 * @interface TrademarkRequestList200ResponsePagination
 */
export interface TrademarkRequestList200ResponsePagination {
  /**
   * Всего записей под текущие фильтры
   * @type {number}
   * @memberof TrademarkRequestList200ResponsePagination
   */
  totalRecords: number
  /**
   * Текущая страница
   * @type {number}
   * @memberof TrademarkRequestList200ResponsePagination
   */
  page: number
  /**
   * Записей на странице
   * @type {number}
   * @memberof TrademarkRequestList200ResponsePagination
   */
  perPage: number
  /**
   * Номер последней страницы
   * @type {number}
   * @memberof TrademarkRequestList200ResponsePagination
   */
  lastPage: number
}

/**
 * Check if a given object implements the TrademarkRequestList200ResponsePagination interface.
 */
export function instanceOfTrademarkRequestList200ResponsePagination(
  value: object
): value is TrademarkRequestList200ResponsePagination {
  if (!('totalRecords' in value) || value['totalRecords'] === undefined)
    return false
  if (!('page' in value) || value['page'] === undefined) return false
  if (!('perPage' in value) || value['perPage'] === undefined) return false
  if (!('lastPage' in value) || value['lastPage'] === undefined) return false
  return true
}

export function TrademarkRequestList200ResponsePaginationFromJSON(
  json: any
): TrademarkRequestList200ResponsePagination {
  return TrademarkRequestList200ResponsePaginationFromJSONTyped(json, false)
}

export function TrademarkRequestList200ResponsePaginationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TrademarkRequestList200ResponsePagination {
  if (json == null) {
    return json
  }
  return {
    totalRecords: json['totalRecords'],
    page: json['page'],
    perPage: json['perPage'],
    lastPage: json['lastPage'],
  }
}

export function TrademarkRequestList200ResponsePaginationToJSON(
  value?: TrademarkRequestList200ResponsePagination | null
): any {
  if (value == null) {
    return value
  }
  return {
    totalRecords: value['totalRecords'],
    page: value['page'],
    perPage: value['perPage'],
    lastPage: value['lastPage'],
  }
}
